import useSWR from "swr"
import { customFetcherNative, getQueryString } from "../../../../utils";
import { IRampReport, SelectOption } from "../../../../globals/interfaces";
import moment from "moment";

export default function useData (
    enableSearch: boolean,
    flightNumber: string, 
    flightDate: string, 
    type: string,
    unit: string
) {

    const queryString = getQueryString({
        flightNumber,
        flightDate,
        type,
        unit
    });
    
    const searchKey = enableSearch && queryString ? 
        `/ramp-report?${queryString}` : null;
    
    const {
        data,
        mutate,
        isLoading
    } = useSWR(searchKey, customFetcherNative<IRampReport>, {
        fallbackData: []
    });

    const flightsSearchKey = flightDate && moment(flightDate).isValid() ? 
        `/ramp-report/flights/${flightDate}` : null;

    const {
        data: flights,
    } = useSWR(flightsSearchKey, customFetcherNative<string>, {
        fallbackData: []
    });

    const flightOptions: Array<SelectOption> = flights.map(item => ({
        label: item,
        value: item
    }));

    return {
        flightOptions,
        data,
        isLoading,
        mutate
    }
}